import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { WindowContext } from './context';
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function WindowProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isActiveWindow = _useState2[0],
    setActiveWindow = _useState2[1];
  useEffect(function () {
    var visibilityChangeListener = function visibilityChangeListener() {
      switch (document.visibilityState) {
        case 'hidden':
          setActiveWindow(false);
          break;
        case 'visible':
          setActiveWindow(true);
          break;
      }
    };
    if (typeof document === 'undefined' || typeof document.addEventListener !== 'function') return;
    document.addEventListener('visibilitychange', visibilityChangeListener);
    return function () {
      return document.removeEventListener('visibilitychange', visibilityChangeListener);
    };
  }, []);
  return _jsx(WindowContext.Provider, {
    value: isActiveWindow,
    children: children
  });
}